/* ============================================================
   LabelLab Header — section JS
   - Megamenu open/close + position clamp
   - Audience/Gender pills with summary update
   - Sticky-on-scroll
   - Mobile drawer with drill-in flow
   ============================================================ */
(function(){
  'use strict';

  /* ===== Megamenu ===== */
  var triggers = document.querySelectorAll('.ll-h-nav .has-menu');
  triggers.forEach(function(item){
    var link = item.querySelector(':scope > a');
    if(!link) return;
    link.addEventListener('click', function(e){
      e.preventDefault();
      var isOpen = item.classList.toggle('open');
      link.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      triggers.forEach(function(t){
        if(t !== item){
          t.classList.remove('open');
          var a = t.querySelector(':scope > a');
          if(a) a.setAttribute('aria-expanded','false');
        }
      });
    });
  });
  document.addEventListener('click', function(e){
    if(!e.target.closest('.ll-h-nav .has-menu')){
      triggers.forEach(function(t){
        t.classList.remove('open');
        var a = t.querySelector(':scope > a');
        if(a) a.setAttribute('aria-expanded','false');
      });
    }
  });

  function clampMegamenu(mm){
    if (!mm) return;
    mm.style.marginLeft = '';
    var r = mm.getBoundingClientRect();
    if (r.width === 0) return;
    var pad = 16;
    var oR = r.right - (window.innerWidth - pad);
    var oL = pad - r.left;
    if (oR > 0) mm.style.marginLeft = (-oR) + 'px';
    else if (oL > 0) mm.style.marginLeft = oL + 'px';
  }
  triggers.forEach(function(item){
    var run = function(){
      requestAnimationFrame(function(){
        clampMegamenu(item.querySelector('.ll-h-megamenu'));
      });
    };
    item.addEventListener('mouseenter', run);
    var a = item.querySelector(':scope > a');
    if (a) a.addEventListener('click', run);
    new MutationObserver(run).observe(item, {attributes:true, attributeFilter:['class']});
  });
  window.addEventListener('resize', function(){
    document.querySelectorAll('.ll-h-megamenu').forEach(clampMegamenu);
  });

  /* ===== Pills (single-select; optional groups can deselect) ===== */
  document.querySelectorAll('.ll-h-mmf-pills').forEach(function(group){
    var optional = group.hasAttribute('data-optional');
    group.addEventListener('click', function(e){
      var btn = e.target.closest('.ll-h-mmf-pill');
      if(!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var alreadyOn = btn.getAttribute('aria-pressed') === 'true';
      group.querySelectorAll('.ll-h-mmf-pill').forEach(function(b){
        b.setAttribute('aria-pressed','false');
      });
      if (!(optional && alreadyOn)) btn.setAttribute('aria-pressed','true');
      updateSummaries(group);
    });
  });
  function applyFiltersToRows(audKey, genKey){
    /* genKey may be null (no gender selected = "all"). Pick the matching
       data-c-{audience}-{gender|all} attribute, swap the visible count,
       hide rows that are 0 for the active combo. */
    var attr = 'data-c-' + audKey + '-' + (genKey || 'all');
    document.querySelectorAll('a[data-row]').forEach(function(a){
      var n  = parseInt(a.getAttribute(attr) || '0', 10);
      var ct = a.querySelector('.ct');
      if (ct) ct.textContent = n;
      a.style.display = (n === 0) ? 'none' : '';
    });
    /* Swap View All href + label based on audience only. */
    document.querySelectorAll('a[data-viewall]').forEach(function(a){
      var href  = (audKey === 'kids') ? a.dataset.hrefKids  : a.dataset.hrefAdults;
      var label = (audKey === 'kids') ? a.dataset.labelKids : a.dataset.labelAdults;
      if (href)  a.setAttribute('href', href);
      var lbl = a.querySelector('[data-viewall-label]');
      if (lbl && label) lbl.textContent = label;
    });
  }

  function updateSummaries(scope){
    var root = scope.closest('[data-megamenu-filters]') || scope.closest('.ll-d-filterbar');
    if(!root) return;
    var aud = root.querySelector('[data-audience][aria-pressed="true"]');
    var gen = root.querySelector('[data-gender][aria-pressed="true"]');
    var audKey  = aud ? aud.getAttribute('data-audience') : 'adults';
    var genKey  = gen ? gen.getAttribute('data-gender')   : null;

    /* Mirror state on every other filterbar so desktop + mobile drawer
       stay in lock-step. Do this BEFORE recomputing so the visible sum
       below also reads the new state. */
    document.querySelectorAll('[data-megamenu-filters]').forEach(function(other){
      if (other === root) return;
      other.querySelectorAll('[data-audience]').forEach(function(b){
        b.setAttribute('aria-pressed', b.getAttribute('data-audience') === audKey ? 'true' : 'false');
      });
      other.querySelectorAll('[data-gender]').forEach(function(b){
        if (genKey === null) b.setAttribute('aria-pressed','false');
        else b.setAttribute('aria-pressed', b.getAttribute('data-gender') === genKey ? 'true' : 'false');
      });
    });

    applyFiltersToRows(audKey, genKey);

    /* Sum visible row counts so the summary reflects the actual total. */
    var sum = 0;
    document.querySelectorAll('a[data-row]').forEach(function(a){
      if (a.style.display === 'none') return;
      var ct = a.querySelector('.ct');
      if (ct) sum += parseInt(ct.textContent, 10) || 0;
    });
    /* The desktop megamenu and mobile drawer share the same data-row
       set; querySelectorAll picks both up so we'd double-count. Halve
       only when both sets exist. */
    var hasDesk = !!document.querySelector('.ll-h-mm-grid a[data-row]');
    var hasMob  = !!document.querySelector('.ll-d-groups a[data-row]');
    if (hasDesk && hasMob) sum = Math.round(sum / 2);

    var audLabel = (audKey === 'kids' ? 'Kids' : 'Adults');
    var genLabel = 'All genders';
    if (genKey) genLabel = genKey.charAt(0).toUpperCase() + genKey.slice(1);
    var text = sum + ' styles · ' + audLabel + ' · ' + genLabel;
    document.querySelectorAll('[data-megamenu-summary],[data-drawer-summary]').forEach(function(el){
      el.textContent = text;
    });
  }

  /* Initial pass — make sure rows + view-all + summary reflect the
     default pill state at first render. Synthesise a click target so
     updateSummaries() does its full job. */
  (function initFilters(){
    var firstFilters = document.querySelector('[data-megamenu-filters]');
    if (!firstFilters) return;
    var anyPill = firstFilters.querySelector('[data-audience]');
    if (anyPill) updateSummaries(anyPill);
  })();

  /* ===== Sticky on scroll ===== */
  var shell = document.querySelector('[data-header-shell]');
  if (shell) {
    var header = document.querySelector('[data-header]');
    var spacer = shell.querySelector('.ll-h-spacer');
    var stickAt = 0;
    function measure(){
      var an = document.querySelector('.ll-h-announce');
      stickAt = an ? an.offsetHeight : 0;
      if (spacer && header) spacer.style.height = header.offsetHeight + 'px';
    }
    function onScroll(){
      if (window.scrollY > stickAt) shell.classList.add('is-stuck');
      else shell.classList.remove('is-stuck');
    }
    measure();
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', measure);
  }

  /* ===== Mobile drawer ===== */
  var drawer = document.getElementById('ll-drawer');
  var burger = document.querySelector('[data-burger]');
  if (drawer) {
    var stage = drawer.querySelector('.ll-d-stage');
    function openDrawer(){
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden','false');
      if (burger) burger.setAttribute('aria-expanded','true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer(){
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden','true');
      if (burger) burger.setAttribute('aria-expanded','false');
      document.body.style.overflow = '';
      setTimeout(function(){ if (stage) stage.dataset.screen = 'root'; }, 300);
    }
    function drillTo(name){
      if (!stage) return;
      stage.dataset.screen = 'child';
      stage.dataset.child = name;
      var child = stage.querySelector('.ll-d-screen.child');
      if (child) child.scrollTop = 0;
    }
    function drillBack(){ if (stage) stage.dataset.screen = 'root'; }

    if (burger) burger.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-drawer-close]').forEach(function(el){
      el.addEventListener('click', closeDrawer);
    });
    drawer.querySelectorAll('[data-drill]').forEach(function(el){
      el.addEventListener('click', function(){ drillTo(el.dataset.drill); });
    });
    drawer.querySelectorAll('[data-back]').forEach(function(el){
      el.addEventListener('click', drillBack);
    });
    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape'){
        triggers.forEach(function(t){ t.classList.remove('open'); });
        if (drawer.classList.contains('open')){
          if (stage && stage.dataset.screen !== 'root') drillBack();
          else closeDrawer();
        }
      }
    });
  }
})();
